import { ChangeDetectionStrategy, Component, Inject, Input, OnChanges, SimpleChanges, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SERVER_URL } from '@core/core.tokens';
import { FileJson } from '@core/models/built/session-step-value-json.model';
import { SessionStep } from '@core/models/session.model';
import { BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
  templateUrl: './file-report.component.html',
  styles: [`
    img.small {
      height: 100px;
      cursor: pointer;
      border: 2px solid var(--accent);
    }
    img.small:hover {
      border: 2px solid var(--primary);
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileReportComponent implements OnChanges {

  @Input() step!: SessionStep;

  private step$$ = new BehaviorSubject<SessionStep>(this.step);
  step$ = this.step$$.asObservable();

  values$ = this.step$.pipe(map(step => step.values?.map(v => v.value as FileJson) || []));

  images$ = this.values$.pipe(
    map(values => {
      const result = values.reduce((acc, curr) => {
        if (curr.mimeType.indexOf('image') > -1) {
          acc = [...acc, `${this.serverUrl}${curr.path}`];
        }
        return acc;
      }, [] as string[]);
      return result || [];
    })
  );

  files$ = this.values$.pipe(
    map(values => {
      const result = values.reduce((acc, curr) => {
        if (curr.mimeType.indexOf('image') <= -1) {
          acc = [...acc, curr];
        }
        return acc;
      }, [] as FileJson[]);
      return result || [];
    })
  );

  constructor(
    @Inject(SERVER_URL) public serverUrl: string,
    private dialog: MatDialog
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.step) {
      this.step$$.next(changes.step.currentValue);
    }
  }

  open(img: string, template: TemplateRef<any>) {
    this.dialog.open(template, { data: { img } });
  }

}
